(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsVersioning(
            module.exports
        );

    } else {
        RivalIQ.module('enums');

        enumsVersioning(
            RivalIQ.enums
        );
    }

    function enumsVersioning(exports) {
        exports.versioning = {
            landscape: {
                data: 'Version-Data-Landscape',
                metadata: 'Version-Metadata-Landscape'
            },
            user: {
                data: 'Version-Data-User',
                metadata: 'Version-Metadata-User'
            }
        };
    }

}());
